(ns app.front.view.project.deficiencies
  (:require [app.front.entities :as entities]
            [app.front.view.inspections.summary-subsection :as inspections-summary-subsection]
            [app.front.view.project.subs :as ps]
            [core.front.i18n :as i18n]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::project-execution-ids
  (ps/child-entity-sub-signal-fn ::ps/project-workspace-ids)
  (ps/child-entity-sub-fn :entity.type/execution))

(rf/reg-sub ::project-inspection-ids
  (ps/child-entity-sub-signal-fn ::project-execution-ids)
  (ps/child-entity-sub-fn :entity.type/inspection))

(rf/reg-sub ::has-any-inspections?
  (fn [[_ project-id]]
    (rf/subscribe [::project-inspection-ids project-id]))
  ps/sub-has-ids?)

(rf/reg-sub ::project-inspection-deficiency-ids
  (ps/child-entity-sub-signal-fn ::project-inspection-ids)
  (ps/child-entity-sub-fn :entity.type/inspection-deficiency))

(rf/reg-sub ::project-inspection-order-ids
  (ps/child-entity-sub-signal-fn ::project-execution-ids)
  (ps/child-entity-sub-fn :entity.type/inspection-order))

(rf/reg-sub ::project-deficiencies
  (fn [[_ project-id]]
    [(rf/subscribe [::entities/context])
     (rf/subscribe [::project-inspection-deficiency-ids project-id])
     (rf/subscribe [::i18n/full-locale])
     (rf/subscribe [:language])])
  (fn [[ctx deficiency-ids locale lang] _]
    (->> (entities/find-entities ctx deficiency-ids)
         (inspections-summary-subsection/group-deficiencies locale lang))))

(rf/reg-sub ::project-orders
  (fn [[_ project-id]]
    [(rf/subscribe [::entities/context])
     (rf/subscribe [::project-inspection-order-ids project-id])
     (rf/subscribe [::i18n/full-locale])
     (rf/subscribe [:language])])
  (fn [[ctx order-ids locale lang] _]
    (->> (entities/find-entities ctx order-ids)
         (inspections-summary-subsection/group-orders locale lang))))

(rf/reg-sub ::has-deficiencies?
  (fn [[_ project-id]]
    (rf/subscribe [::project-deficiencies project-id]))
  ps/sub-has-ids?)

(rf/reg-sub ::has-orders?
  (fn [[_ project-id]]
    (rf/subscribe [::project-orders project-id]))
  ps/sub-has-ids?)
